import fileStackPlugin from "./filestack_editor_plugin";
import * as Dialog from "./dialog";

/* global grapesjs */

let editor = null;

const initGrapeJs = (fileStackButton) => {
  const grapesJsPresetWebpage = grapesjs.plugins.get("gjs-preset-webpage");
  const height = window.innerHeight - 150;

  editor = grapesjs.init({
    storageManager: {
      autoload: false,
    },
    container: "#gjs",
    fromElement: true,
    height: `${height}px`,
    protectedCss: 'img, div[data-gjs-type="video"], div[data-gjs-type="map"] {max-width:100%;} html {font-family: "Lato"}',
    canvas: {
      styles: ["https://fonts.googleapis.com/css?family=Lato|Passion+One:700|Gochi+Hand|Open+Sans:700,400|Work+Sans:900"],
    },
    plugins: [fileStackPlugin, grapesJsPresetWebpage],
    pluginsOpts: {
      [fileStackPlugin]: {
        key: window._filepicker_key,
        btnEl: fileStackButton,
      },
      [grapesJsPresetWebpage]: {
        formsOpts: false,
        countdownOpts: false,
        navbarOpts: false,
        textCleanCanvas: "Êtes-vous sûr de vouloir effacer complètement la page ?",
        blocksBasicOpts: {
          labelColumn1: "1 Colonne",
          labelColumn2: "2 Colonnes",
          labelColumn3: "3 Colonnes",
          labelColumn37: "2 Colonnes 3/7",
          labelText: "Texte",
          labelLink: "Lien",
          labelVideo: "Vidéo",
          labelMap: "Carte",
          stylePrefix: "gjs-",
          flexGrid: 1,
        },
        customStyleManager: [
          {
            name: "Typographie",
            open: false,
            buildProps: ["font-family", "font-size", "font-weight", "color", "text-align", "text-shadow"],
            properties: [
              {
                name: "Police",
                property: "font-family",
                defaults: "Lato",
                list: [
                  { value: "Gochi Hand, cursive", name: "Gochi Hand" },
                  { value: "Lato", name: "Lato" },
                  { value: "Open Sans", name: "Open Sans" },
                  { value: "Passion One", name: "Passion One" },
                  { value: "Work Sans", name: "Work Sans" },
                ],
              },
              {
                name: "Taille",
                property: "font-size",
              },
              {
                name: "Couleur",
                property: "color",
              },
              {
                name: "Ombrage",
                property: "text-shadow",
              },
              {
                name: "Alignement",
                property: "text-align",
                list: [
                  {
                    value: "left",
                    className: "fa fa-align-left",
                  },
                  {
                    value: "center",
                    className: "fa fa-align-center",
                  },
                  {
                    value: "right",
                    className: "fa fa-align-right",
                  },
                  {
                    value: "justify",
                    className: "fa fa-align-justify",
                  },
                ],
              },
              {
                name: "Epaisseur",
                property: "font-weight",
                list: [
                  {
                    value: "normal",
                    name: "Normale",
                  },
                  {
                    value: "bold",
                    name: "Gras",
                  },
                ],
              },
            ],
          },
          {
            id: "deco",
            name: "Décorations",
            open: false,
            buildProps: ["opacity", "border-radius-c", "border", "box-shadow", "background-color", "background"],
            properties: [
              {
                name: "Opacité",
                type: "slider",
                property: "opacity",
                defaults: 1,
                step: 0.01,
                max: 1,
                min: 0,
              },
              {
                name: "Bordure arrondie",
                property: "border-radius",
              },
              {
                name: "Bordure",
                property: "border",
                properties: [
                  {
                    name: "Style",
                    property: "border-style",
                    list: [
                      {
                        value: "solid",
                      },
                      {
                        value: "dashed",
                      },
                    ],
                  },
                  {
                    name: "Epaisseur",
                    property: "border-width",
                  },
                  {
                    name: "Couleur",
                    property: "border-color",
                  },
                ],
              },
              {
                name: "Ombrages",
                property: "box-shadow",
                // properties: [
                //   {
                //     property: 'box-shadow-color'
                //   },
                //   {
                //     property: 'box-shadow-blur'
                //   },
                //   {
                //     property: 'box-shadow-type'
                //   }
                // ]
              },
              {
                name: "Couleur de fond",
                property: "background-color",
              },
              {
                name: "Fond",
                property: "background",
                properties: [
                  {
                    name: "Taille",
                    property: "background-size",
                  },
                  {
                    name: "Image",
                    property: "background-image",
                  },
                ],
              },
            ],
          },
          {
            name: "Avancé",
            open: false,
            buildProps: ["width", "height", "max-width", "min-height", "margin", "padding"],
            properties: [
              {
                name: "Largeur",
                property: "width",
              },
              {
                name: "Hauteur",
                property: "height",
              },
              {
                name: "Largeur max",
                property: "max-width",
              },
              {
                name: "Hauteur min",
                property: "min-height",
              },
              {
                name: "Marge",
                property: "margin",
                properties: [
                  {
                    name: "Marge haut",
                    property: "margin-top",
                  },
                  {
                    name: "Marge bas",
                    property: "margin-bottom",
                  },
                  {
                    name: "Marge gauche",
                    property: "margin-left",
                  },
                  {
                    name: "Marge droite",
                    property: "margin-right",
                  },
                ],
              },
              {
                name: "Padding",
                property: "padding",
                properties: [
                  {
                    name: "Padding haut",
                    property: "padding-top",
                  },
                  {
                    name: "Padding bas",
                    property: "padding-bottom",
                  },
                  {
                    name: "Padding gauche",
                    property: "padding-left",
                  },
                  {
                    name: "Padding droite",
                    property: "padding-right",
                  },
                ],
              },
              {
                name: "Flex Container",
                property: "display",
                type: "select",
                defaults: "block",
                list: [
                  {
                    value: "block",
                    name: "Disable",
                  },
                  {
                    value: "flex",
                    name: "Enable",
                  },
                ],
              },
              {
                name: "Flex Parent",
                property: "label-parent-flex",
                type: "integer",
              },
              {
                name: "Flex Direction",
                property: "flex-direction",
                type: "radio",
                defaults: "row",
                list: [
                  {
                    value: "row",
                    name: "Row",
                    className: "icons-flex icon-dir-row",
                    title: "Row",
                  },
                  {
                    value: "row-reverse",
                    name: "Row reverse",
                    className: "icons-flex icon-dir-row-rev",
                    title: "Row reverse",
                  },
                  {
                    value: "column",
                    name: "Column",
                    title: "Column",
                    className: "icons-flex icon-dir-col",
                  },
                  {
                    value: "column-reverse",
                    name: "Column reverse",
                    title: "Column reverse",
                    className: "icons-flex icon-dir-col-rev",
                  },
                ],
              },
              {
                name: "Justify Content",
                property: "justify-content",
                type: "radio",
                defaults: "flex-start",
                list: [
                  {
                    value: "flex-start",
                    className: "icons-flex icon-just-start",
                    title: "Start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-just-end",
                  },
                  {
                    value: "space-between",
                    title: "Space between",
                    className: "icons-flex icon-just-sp-bet",
                  },
                  {
                    value: "space-around",
                    title: "Space around",
                    className: "icons-flex icon-just-sp-ar",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-just-sp-cent",
                  },
                ],
              },
              {
                name: "Align Items",
                property: "align-items",
                type: "radio",
                defaults: "center",
                list: [
                  {
                    value: "flex-start",
                    title: "Start",
                    className: "icons-flex icon-al-start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-al-end",
                  },
                  {
                    value: "stretch",
                    title: "Stretch",
                    className: "icons-flex icon-al-str",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-al-center",
                  },
                ],
              },
              {
                name: "Flex Children",
                property: "label-parent-flex",
                type: "integer",
              },
              {
                name: "Order",
                property: "order",
                type: "integer",
                defaults: 0,
                min: 0,
              },
              {
                name: "Flex",
                property: "flex",
                type: "composite",
                properties: [
                  {
                    name: "Grow",
                    property: "flex-grow",
                    type: "integer",
                    defaults: 0,
                    min: 0,
                  },
                  {
                    name: "Shrink",
                    property: "flex-shrink",
                    type: "integer",
                    defaults: 0,
                    min: 0,
                  },
                  {
                    name: "Basis",
                    property: "flex-basis",
                    type: "integer",
                    units: ["px", "%", ""],
                    unit: "",
                    defaults: "auto",
                  },
                ],
              },
              {
                name: "Align Self",
                property: "align-self",
                type: "radio",
                defaults: "auto",
                list: [
                  {
                    value: "auto",
                    name: "Auto",
                  },
                  {
                    value: "flex-start",
                    title: "Start",
                    className: "icons-flex icon-al-start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-al-end",
                  },
                  {
                    value: "stretch",
                    title: "Stretch",
                    className: "icons-flex icon-al-str",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-al-center",
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    styleManager: {
      textNoElement: "Sélectionnez un objet",
    },
    assetManager: {
      addBtnText: "Ajouter une image",
      modalTitle: "Sélectionner une image",
    },
    traitManager: {
      textNoElement: "Sélectionnez un objet",
      labelContainer: "Paramètres du composant",
    },
    colorPicker: {
      appendTo: "parent",
      offset: {
        top: 26,
        left: -165,
      },
    },
  });

  const pn = editor.Panels;
  const bm = editor.BlockManager;
  const comps = editor.DomComponents;

  bm.get("text").attributes.content.content = "Insérez votre texte ici";
  bm.get("link").attributes.content.content = "Lien";

  const traitTranslations = {
    map: {
      Address: "Adresse",
      "Map type": "Type de carte",
    },
    video: {
      Provider: "Fournisseur",
      Poster: "Aperçu",
      Autoplay: "Lecture auto",
      Loop: "Boucle",
      Controls: "Contrôles",
    },
  };

  const updateType = (type) => {
    const originalType = comps.getType(type);

    const newTraits = originalType.model.prototype.defaults.traits.map((trait) => {
      if (trait.label) {
        trait.label = traitTranslations[type][trait.label] || trait.label;
      }
      return trait;
    });

    comps.addType(type, {
      model: originalType.model.extend({
        defaults: Object.assign({}, originalType.model.prototype.defaults, {
          traits: newTraits,
        }),
      }),
      view: originalType.view,
    });
  };

  // sadly, video does not seem to have same properties (they are dynamic), so it's only maps for now. But the logic is ready
  updateType("map");

  editor.on("load", function () {
    // Add Settings Sector

    var openTmBtn = pn.getButton("views", "open-tm");
    openTmBtn && openTmBtn.set("active", 1);

    var traitsSector = $(
      '<div class="gjs-sm-sector no-select">' +
        '<div class="gjs-sm-title"><span class="fa fa-cog"></span> Paramètres</div>' +
        '<div class="gjs-sm-properties" style="display: none;"></div></div>'
    );
    var traitsProps = traitsSector.find(".gjs-sm-properties");
    traitsProps.append($(".gjs-trt-traits"));
    $(".gjs-sm-sectors").before(traitsSector);
    traitsSector.find(".gjs-sm-title").on("click", function () {
      var traitStyle = traitsProps.get(0).style;
      var hidden = traitStyle.display == "none";
      if (hidden) {
        traitStyle.display = "block";
      } else {
        traitStyle.display = "none";
      }
    });

    bm.render([
      bm.get("text"),
      bm.get("link"),
      bm.get("image"),
      bm.get("video"),
      bm.get("map"),
      bm.get("column1"),
      bm.get("column2"),
      bm.get("column3"),
    ]);
  });
};

const loadData = () => {
  const data = $(".edit-html").data("grapejs");
  const css = $(".edit-html").data("css");
  editor.setComponents(data);
  editor.setStyle(css);
};

const saveAjaxRequest = (data) => {
  const method = $(".edit-html").data("my-method") || "POST";
  const save_url = $(".edit-html").data("save-url");
  const redirect_url = $(".edit-html").data("redirect-url");

  ajax({
    method: method,
    url: save_url,
    data: data,
    success: function () {
      window.location.href = redirect_url;
    },
    error: function (e) {
      console.error("error", e);
    },
  });
};

function handleUpgradeButton() {
  const upgradeBtnEl = document.querySelector(".js-btn-editor-upgrade");

  if (!upgradeBtnEl) {
    return;
  }

  upgradeBtnEl.addEventListener("click", async (event) => {
    const isYes = await Dialog.yesNo(
      "Attention",
      "Ceci va supprimer le contenu de votre éditeur. Êtes-vous certain de vouloir continuer l'opération ?"
    );

    if (isYes) {
      window.ajax({
        url: event.target.dataset.url,
        method: "POST",
        error: function () {
          Dialog.alertError(
            "Une erreur est survenue",
            "Veuillez réessayer l'opération. En cas de problème, veuillez contacter le support."
          );
        },
        success: function () {
          location.reload();
        },
      });
    }
  });
}

const clickAddBlockButton = () => {
  setTimeout(() => {
    document.querySelectorAll(".gjs-pn-views .fa-th-large").forEach((icon) => icon.click());
  }, 500);
};

export const onGrapeJsSave = () => {
  const components = editor.getComponents();
  const css = editor.getCss();
  const html = editor.getHtml();
  const owner_type = $(".edit-html").data("owner-type");

  const data = {};
  data[`${owner_type}[grapejs]`] = JSON.stringify(components);
  data[`${owner_type}[html]`] = html;
  data[`${owner_type}[css]`] = css;

  saveAjaxRequest(data);
};

export const initGrapeEditor = () => {
  if (window.grapesjs) {
    const fileStackButton = document.createElement("button");
    fileStackButton.className = "btn btn-raised btn-primary btn-xs";
    fileStackButton.innerHTML = "Ajouter des images";
    initGrapeJs(fileStackButton);
    loadData();
    handleUpgradeButton();
    clickAddBlockButton();
  } else {
    setTimeout(initGrapeEditor, 200);
  }
};
